import React from 'react';
import { Phone } from 'lucide-react';
import { Button } from './Button';
export function FinalCTA() {
  return <section id="contact" className="bg-accent py-20 relative overflow-hidden" data-id="element-33">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#09090b 2px, transparent 2px)',
      backgroundSize: '20px 20px'
    }} data-id="element-34" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-35">
        <h2 className="font-display text-4xl md:text-6xl text-dark uppercase tracking-wide mb-6" data-id="element-36">
          Ready for the <span className="text-white" data-id="element-37">Industrial Clean?</span>
        </h2>
        <p className="text-dark font-bold text-xl md:text-2xl mb-10 max-w-2xl mx-auto" data-id="element-38">
          Get your free, no-obligation estimate today and restore your
          property's curb appeal.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full sm:w-auto" data-id="element-39">
          <Button className="w-full sm:w-auto h-16 px-10 bg-dark hover:bg-dark/90 text-white font-bold uppercase tracking-wider text-xl rounded-md shadow-xl" data-id="element-40">
            Book Online
          </Button>
          <Button variant="outline" className="w-full sm:w-auto h-16 px-10 border-4 border-dark text-dark hover:bg-dark hover:text-white font-bold uppercase tracking-wider text-xl rounded-md bg-transparent" data-id="element-41">
            <Phone className="mr-2 h-6 w-6" data-id="element-42" />
            Call 208-716-7525
          </Button>
        </div>
      </div>
    </section>;
}